import styled from "styled-components/macro";
import { PrimaryButton, LabelStringColumn, ButtonText } from "@loanbossinc/component-library";
import { IconButton } from "@material-ui/core";

export const ComparisonWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const StyledOR = styled(LabelStringColumn)`
  font-size: 24px !important;
  align-self: center;
  margin: 0;
  font-weight: 500 !important;
`;

export const Card = styled.div`
  position: relative;
  width: calc(100% - 4em);
  min-height: 160px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  padding: 1em 2em 0.5em 1em;
  margin: 0.5em 2em;
  background: #ffffff;
  border: 1px solid #dadce0;
  box-sizing: border-box;
  box-shadow: 0px 10px 20px rgba(173, 174, 174, 0.25);
  border-radius: 8px;
`;

export const SelectedFieldWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
`;

export const SelectedFieldLeftSection = styled.div`
  display: flex;
  align-items: center;
`;

export const SelectedFieldInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const StyledIconButton = styled(IconButton)`
  && {
    width: 18px !important;
    padding: 0;
    background: none;
    border: none;
    margin-right: 2em;
  }

  &:hover {
    background: none !important;
  }
`;

export const FieldNameWrapper = styled.div`
  && {
    font-family: WorkSans;
    font-size: 14px;
    font-weight: 600;
  }
`;

export const FieldTypeWrapper = styled.div`
  && {
    color: #5f6368;
    font-size: 14px;
    font-weight: 400;
    font-family: WorkSans;
  }
`;

export const StyledPropertySelectWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5em;
`;

export const StyledSelectButton = styled(PrimaryButton)`
  width: ${props => `${props.w} !important`};
  height: ${props => `${props.h} !important`};
  background-color: #005aa9 !important;
  font-size: 14px !important;
`;

export const StyledCloseIconButton = styled(IconButton)`
  && {
    position: absolute;
    width: 24px;
    height: 24px;
    top: 3px;
    right: 3px;
  }
`;

export const StyledButtonText = styled(ButtonText)`
    & .MuiButton-label .material-icons {
    margin-right: 10px !important;
  }
`;
